import { FC, MouseEvent } from 'react'
import styles from './styles.module.scss'
import { Link } from '../Link'
import './otButton.css'

export interface FooterLinkSectionProps {
  sys: {
    id: string
  }
  fields: {
    title: string
    isPrivacy: boolean
    footerLinks: FooterLink[]
  }
}

export type FooterLink = {
  sys: {
    id: string
  }
  fields: {
    url: string
    name: string
  }
}
export const LinkSection: FC<FooterLinkSectionProps> = (
  section: FooterLinkSectionProps,
) => {
  const preventDefaultHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  return (
    <div key={section.sys.id} className={styles.linkSection}>
      <div className={styles.title}>{section.fields.title}</div>
      <ul id={section.sys.id}>
        {section.fields.footerLinks.map((link: FooterLink) => {
          return (
            <li key={link.sys.id}>
              <Link url={link.fields.url} title={link.fields.name}>
                {link.fields.name}
              </Link>
            </li>
          )
        })}
        {section.fields.isPrivacy && (
          <li>
            <button
              onClick={preventDefaultHandler}
              id="ot-sdk-btn"
              title="Cookie Preferences"
              tabIndex={0}
              className={`${styles.oneTrustLink} optanon-show-settings`}
            >
              Cookie Preferences
            </button>
          </li>
        )}
      </ul>
    </div>
  )
}
